'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withIntegrations;

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _facebook = require('../../integrations/facebook');

var _facebook2 = _interopRequireDefault(_facebook);

var _s = require('../../integrations/s3');

var _s2 = _interopRequireDefault(_s);

var _stripe = require('../../integrations/stripe');

var _stripe2 = _interopRequireDefault(_stripe);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function withIntegrations(WrappedComponent) {
  return function WithIntegration(props) {
    var wrapped = WrappedComponent;

    if (props.config) {
      if (_facebook2.default.hasIntegration(props.config)) {
        wrapped = _facebook2.default.apply(wrapped);
      }

      if (_s2.default.hasIntegration(props.config)) {
        wrapped = _s2.default.apply(wrapped);
      }

      if (_stripe2.default.hasIntegration(props.config)) {
        wrapped = _stripe2.default.apply(wrapped);
      }
    }

    return (0, _reactHyperscript2.default)(wrapped, props);
  };
}